@if ({
  draftSkills: draftSkills$ | async,
  savedSkills: savedSkills$ | async,
  suggestions: suggestions$ | async,
  hasExactMatch: hasExactMatch$ | async,
  moderationLastChangeDate: moderationLastChangeDate$ | async
}; as data) {
  <hrra-jobseeker-skills-edit-form
    [title]="title"
    [draftSkills]="data.draftSkills"
    [suggestions]="data.suggestions"
    [hasExactMatch]="!!data.hasExactMatch"
    [saveDisabled]="!data.draftSkills?.length && !data.savedSkills?.length"
    (onQueryChange)="onQueryChange($event)"
    (onSelectSkill)="onSelectSkill($event)"
    (onAddCustomSkill)="onAddCustomSkill($event)"
    (onRemoveSkill)="onRemoveSkill($event)"
    (onReorderSkills)="onReorderSkills($event)"
    (onSave)="onSave(data.moderationLastChangeDate)"
  ></hrra-jobseeker-skills-edit-form>
}
